import { render, staticRenderFns } from "./PayerNotes.vue?vue&type=template&id=4b500610&scoped=true"
import script from "./PayerNotes.vue?vue&type=script&lang=js"
export * from "./PayerNotes.vue?vue&type=script&lang=js"
import style0 from "./PayerNotes.vue?vue&type=style&index=0&id=4b500610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b500610",
  null
  
)

export default component.exports